/*
  gb-variant-explorer.js
  Componente "esplora varianti" condiviso fra la pagina collezione
  (sections/gb-collection.liquid) e la pagina Vogue Pool
  (sections/gb-vogue-pool.liquid).

  Si aspetta nel DOM, con id suffissato dal section id, i contenitori vuoti:
    gbc-subtabs-{sid}  gbc-swatches-{sid}
    gbc-stage-{sid}    gbc-code-{sid}   gbc-count-{sid}   gbc-thumbs-{sid}
    gbc-vname-{sid}    gbc-vsub-{sid}   gbc-formats-{sid}
    gbc-special-wrap-{sid}  gbc-special-{sid}  gbc-specs-{sid}
  più i bottoni `.gbc-detail .gbc-nav[data-dir]` dentro `root`.

  Uso:
    var ex = GBVariantExplorer(root, sid, { showSubtitle: true });
    ex.setData({ subcollections: [...], variants: [...] });

  setData() può essere richiamato quante volte serve: Vogue Pool lo usa a ogni
  cambio di applicazione per sostituire l'intero set di superfici.

  Formato dei dati (prodotto da snippets/gb-variant-json.liquid):
    subcollections: [{ name, subtitle?, cover }]
    variants:       [{ group, title, subtitle, swatch, gallery[], formats[], special[], info }]
*/
(function () {
  function esc(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // rich_text_field di Shopify (JSON) → HTML
  function richText(n) {
    if (!n) return '';

    if (typeof n === 'string') {
      try {
        n = JSON.parse(n);
      } catch (e) {
        return esc(n);
      }
    }

    function r(x) {
      if (!x) return '';

      var c = (x.children || []).map(r).join('');

      switch (x.type) {
        case 'root':
          return c;

        case 'paragraph':
          return '<p>' + c + '</p>';

        case 'heading':
          var L = x.level || 3;
          return '<h' + L + '>' + c + '</h' + L + '>';

        case 'list':
          return '<ul>' + c + '</ul>';

        case 'list-item':
          return '<li>' + c + '</li>';

        case 'link':
          return '<a href="' + esc(x.url) + '" target="_blank" rel="noopener">' + c + '</a>';

        case 'text':
          var t = esc(x.value);

          if (x.bold) {
            t = '<strong>' + t + '</strong>';
          }

          if (x.italic) {
            t = '<em>' + t + '</em>';
          }

          return t;

        default:
          return c;
      }
    }

    return r(n);
  }

  // scheda tecnica in markdown "**chiave:** valore" → [{k, v}]
  function parseInfo(md) {
    if (!md) return [];

    return md
      .split(/\n\n+/)
      .map(function (b) {
        var m = b.match(/\*\*(.+?):\*\*\s*([\s\S]*)/);

        return m
          ? {
              k: m[1],
              v: m[2].trim()
            }
          : null;
      })
      .filter(Boolean);
  }

  // il titolo prodotto è "Collezione – Variante": mostriamo solo la variante
  function vlabel(v) {
    return v.title.indexOf(' – ') > -1
      ? v.title.split(' – ').slice(1).join(' – ')
      : v.title;
  }

  function GBVariantExplorer(root, sid, opts) {
    opts = opts || {};

    var $ = function (id) {
      return document.getElementById(id + '-' + sid);
    };

    var variants = [];
    var subs = [];
    var groups = [];
    var hasGroups = false;

    var curGroup = null;
    var vi = 0;
    var gi = 0;
    var gallery = [];

    function groupVariants(g) {
      return variants.filter(function (v) {
        return v.group === g;
      });
    }

    function current() {
      var list = hasGroups
        ? groupVariants(curGroup)
        : variants;

      return list[vi];
    }

    function renderSubtabs() {
      var c = $('gbc-subtabs');

      if (!c) return;

      if (!hasGroups) {
        c.style.display = 'none';
        return;
      }

      c.style.display = '';
      c.innerHTML = '';

      groups.forEach(function (g) {
        var meta =
          subs.filter(function (s) {
            return s.name === g;
          })[0] || {};

        var b = document.createElement('button');

        b.type = 'button';
        b.className = g === curGroup ? 'on' : '';
        b.setAttribute('aria-pressed', String(g === curGroup));

        var label = '<span>' + esc(g);

        if (
          opts.showSubtitle &&
          meta.subtitle
        ) {
          label +=
            '<span class="sub">' +
            esc(meta.subtitle) +
            '</span>';
        }

        label += '</span>';

        b.innerHTML =
          (
            meta.cover
              ? '<img src="' + meta.cover + '" alt="">'
              : ''
          ) +
          label;

        b.onclick = function () {
          curGroup = g;
          vi = 0;
          gi = 0;

          renderSubtabs();
          renderSwatches();
          selectVariant();
        };

        c.appendChild(b);
      });
    }

    function renderSwatches() {
      var c = $('gbc-swatches');

      if (!c) return;

      c.innerHTML = '';

      var list = hasGroups
        ? groupVariants(curGroup)
        : variants;

      list.forEach(function (v, i) {
        var b = document.createElement('button');

        b.type = 'button';
        b.className = i === vi ? 'on' : '';
        b.setAttribute('aria-label', vlabel(v));
        b.setAttribute('aria-pressed', String(i === vi));

        b.innerHTML =
          '<img src="' +
          (v.swatch || '') +
          '" alt=""><span class="tip">' +
          esc(vlabel(v)) +
          '</span>';

        b.onclick = function () {
          vi = i;
          gi = 0;

          selectVariant();
        };

        c.appendChild(b);
      });
    }

    function selectVariant() {
      var sw = $('gbc-swatches');

      if (sw) {
        Array.prototype.forEach.call(
          sw.children,
          function (c, i) {
            c.setAttribute('aria-pressed', String(i === vi));
            c.className =
              i === vi
                ? 'on'
                : '';
          }
        );
      }

      var v = current();

      if (!v) return;

      /*
        AQUATIC CREATURES — SEARCUS

        Searcus appartiene alla collezione Aquatic Creatures.
        I suoi minimali sono lastre 60×120 cm e devono essere
        mostrati integralmente.

        La classe viene aggiunta esclusivamente quando il gruppo
        corrente è:
          - Searcus Decori
          - Searcus Fondi

        Viene automaticamente rimossa quando si seleziona qualsiasi
        altra sottocollezione o variante.
      */
      root.classList.toggle(
        'gbc--searcus',
        (v.group || '').indexOf('Searcus ') === 0
      );

      $('gbc-vname').textContent =
        vlabel(v);

      $('gbc-vsub').textContent =
        v.subtitle || '';

      $('gbc-vsub').style.display =
        v.subtitle
          ? 'block'
          : 'none';

      gallery =
        (v.gallery || []).filter(function (g) { return g && g.url; });

      if (
        gi >= gallery.length
      ) {
        gi = 0;
      }

      var th =
        $('gbc-thumbs');

      th.innerHTML = '';

      gallery.forEach(function (g, i) {
        var button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', vlabel(v) + ' - ' + (i + 1) + ' / ' + gallery.length);
        var im = document.createElement('img');
        im.src = g.url;
        im.alt = '';
        button.appendChild(im);
        button.onclick = function () {
          gi = i;
          paint();
        };
        th.appendChild(button);
      });

      var fm =
        $('gbc-formats');

      fm.innerHTML = '';

      (v.formats || []).forEach(function (f) {
        var d =
          document.createElement('div');

        d.className =
          'fmt';

        var h = '';

        if (f.img) {
          h +=
            '<img src="' +
            f.img +
            '" alt="">';
        }

        if (f.title) {
          h +=
            '<div class="code">' +
            esc(f.title) +
            '</div>';
        }

        if (f.dimensions) {
          h +=
            '<div class="dim">' +
            esc(f.dimensions) +
            '</div>';
        }

        if (f.thickness) {
          h +=
            '<div class="th">sp. ' +
            esc(f.thickness) +
            '</div>';
        }

        d.innerHTML =
          h ||
          esc(f.label || '');

        fm.appendChild(d);
      });

      var spWrap =
        $('gbc-special-wrap');

      var sp =
        $('gbc-special');

      if (
        (v.special || []).length
      ) {
        spWrap.hidden = false;
        sp.innerHTML = '';

        v.special.forEach(function (s) {
          var fig =
            document.createElement('figure');

          fig.innerHTML =
            '<img src="' +
            (s.img || '') +
            '" alt=""><figcaption>' +
            esc(s.title) +
            '</figcaption>';

          sp.appendChild(fig);
        });

      } else {
        spWrap.hidden = true;
      }

      var sc =
        $('gbc-specs');

      sc.innerHTML = '';

      parseInfo(v.info).forEach(function (x) {
        var d =
          document.createElement('div');

        d.innerHTML =
          '<span class="k">' +
          esc(x.k) +
          '</span><span class="v">' +
          esc(x.v) +
          '</span>';

        sc.appendChild(d);
      });

      paint();
    }

    function paint() {
      var stage = $('gbc-stage');
      root.querySelectorAll('.gbc-detail .gbc-nav').forEach(function (b) {
        b.hidden = gallery.length < 2;
      });
      $('gbc-thumbs').hidden = gallery.length < 2;
      $('gbc-count').hidden = gallery.length < 2;
      stage.hidden = !gallery.length;
      stage.tabIndex = gallery.length ? 0 : -1;
      stage.setAttribute('aria-disabled', String(!gallery.length));
      var empty = root.querySelector('.gbc-gallery-empty');
      if (!empty) {
        empty = document.createElement('p');
        empty.className = 'gbc-gallery-empty';
        var locale = (document.documentElement.lang || 'it').split('-')[0];
        empty.textContent = ({it:'Immagine non disponibile',en:'Image unavailable',fr:'Image indisponible',de:'Bild nicht verfügbar'})[locale] || 'Image unavailable';
        stage.parentNode.appendChild(empty);
      }
      empty.hidden = !!gallery.length;
      if (!gallery.length) {
        stage.removeAttribute('src');
        $('gbc-code').textContent = '';
        $('gbc-count').textContent = '';

        return;
      }

      var g =
        gallery[gi];

      $('gbc-stage').src =
        g.url;
      $('gbc-stage').alt = vlabel(current());
      $('gbc-code').hidden = !g.code;

      $('gbc-code').textContent =
        g.code || '';

      $('gbc-count').textContent =
        (gi + 1) +
        ' / ' +
        gallery.length;

      Array.prototype.forEach.call(
        $('gbc-thumbs').children,
        function (c, i) {
          c.setAttribute('aria-pressed', String(i === gi));
          c.className =
            i === gi
              ? 'on'
              : '';
        }
      );
    }

    /* ─────────────────────────────────────────────
       GB product lightbox
       Click sull'immagine principale → visualizzazione
       ingrandita, sempre proporzionata e senza crop.
       ───────────────────────────────────────────── */

    var lightbox = null;
    var lightboxImg = null;
    var lightboxCode = null;
    var lightboxCount = null;
    var lightboxPrev = null;
    var lightboxNext = null;
    var previousBodyOverflow = '';
    var opener = null;
    var inertSiblings = [];

    function containLightboxFocus(e) {
      if (lightbox && !lightbox.hidden && !lightbox.contains(e.target)) {
        lightbox.querySelector('.gbc-lightbox__close').focus();
      }
    }

    function renderLightbox() {
      if (
        !lightbox ||
        !gallery.length
      ) return;

      var g =
        gallery[gi];

      lightboxImg.src =
        g.url;

      lightboxCode.textContent =
        g.code || '';

      lightboxCount.textContent =
        (gi + 1) +
        ' / ' +
        gallery.length;

      var hasMultiple =
        gallery.length > 1;

      lightboxPrev.hidden =
        !hasMultiple;

      lightboxNext.hidden =
        !hasMultiple;
    }

    function closeLightbox() {
      if (
        !lightbox ||
        lightbox.hidden
      ) return;

      lightbox.hidden = true;
      inertSiblings.forEach(function (entry) { entry.element.inert = entry.inert; });
      inertSiblings = [];
      document.removeEventListener('focusin', containLightboxFocus);

      lightbox.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.style.overflow =
        previousBodyOverflow;

      document.removeEventListener(
        'keydown',
        onLightboxKeydown
      );

      var stageImg =
        $('gbc-stage');

      var returnTarget = opener && opener.isConnected ? opener : stageImg;
      if (returnTarget) {
        returnTarget.focus({
          preventScroll: true
        });
      }
    }

    function onLightboxKeydown(e) {
      if (
        !lightbox ||
        lightbox.hidden
      ) return;

      if (e.key === 'Tab') {
        var buttons = Array.prototype.filter.call(lightbox.querySelectorAll('button'), function (b) {
          return !b.hidden && !b.disabled;
        });
        var index = buttons.indexOf(document.activeElement);
        e.preventDefault();
        buttons[(index + (e.shiftKey ? -1 : 1) + buttons.length) % buttons.length].focus();
        return;
      }

      if (
        e.key === 'Escape'
      ) {
        e.preventDefault();

        closeLightbox();

      } else if (
        e.key === 'ArrowLeft' &&
        gallery.length > 1
      ) {
        e.preventDefault();

        gi =
          (
            gi -
            1 +
            gallery.length
          ) %
          gallery.length;

        paint();
        renderLightbox();

      } else if (
        e.key === 'ArrowRight' &&
        gallery.length > 1
      ) {
        e.preventDefault();

        gi =
          (
            gi +
            1
          ) %
          gallery.length;

        paint();
        renderLightbox();
      }
    }

    function ensureLightbox() {
      if (lightbox) return;

      lightbox =
        document.createElement('div');

      lightbox.className =
        'gbc-lightbox';

      lightbox.hidden =
        true;

      lightbox.setAttribute(
        'aria-hidden',
        'true'
      );

      lightbox.innerHTML =
        '<div class="gbc-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Zoom">' +
          '<button class="gbc-lightbox__close" type="button" aria-label="Close">×</button>' +
          '<button class="gbc-lightbox__nav gbc-lightbox__nav--prev" type="button" aria-label="Previous">‹</button>' +
          '<img class="gbc-lightbox__img" alt="">' +
          '<button class="gbc-lightbox__nav gbc-lightbox__nav--next" type="button" aria-label="Next">›</button>' +
          '<div class="gbc-lightbox__meta">' +
            '<span class="gbc-lightbox__code"></span>' +
            '<span class="gbc-lightbox__count"></span>' +
          '</div>' +
        '</div>';

      document.body.appendChild(
        lightbox
      );

      lightboxImg =
        lightbox.querySelector(
          '.gbc-lightbox__img'
        );

      lightboxCode =
        lightbox.querySelector(
          '.gbc-lightbox__code'
        );

      lightboxCount =
        lightbox.querySelector(
          '.gbc-lightbox__count'
        );

      lightboxPrev =
        lightbox.querySelector(
          '.gbc-lightbox__nav--prev'
        );

      lightboxNext =
        lightbox.querySelector(
          '.gbc-lightbox__nav--next'
        );

      lightbox
        .querySelector(
          '.gbc-lightbox__close'
        )
        .onclick =
        closeLightbox;

      lightboxPrev.onclick =
        function (e) {
          e.stopPropagation();

          if (
            gallery.length < 2
          ) return;

          gi =
            (
              gi -
              1 +
              gallery.length
            ) %
            gallery.length;

          paint();
          renderLightbox();
        };

      lightboxNext.onclick =
        function (e) {
          e.stopPropagation();

          if (
            gallery.length < 2
          ) return;

          gi =
            (
              gi +
              1
            ) %
            gallery.length;

          paint();
          renderLightbox();
        };

      lightbox.onclick =
        function (e) {
          if (
            e.target === lightbox
          ) {
            closeLightbox();
          }
        };
    }

    function openLightbox() {
      if (!gallery.length) return;

      ensureLightbox();
      opener = document.activeElement;
      renderLightbox();
      lightboxImg.alt = vlabel(current());
      inertSiblings = Array.prototype.filter.call(document.body.children, function (el) {
        return el !== lightbox && !['SCRIPT', 'STYLE', 'LINK'].includes(el.tagName);
      }).map(function (el) {
        var entry = {element: el, inert: el.inert};
        el.inert = true;
        return entry;
      });
      document.addEventListener('focusin', containLightboxFocus);

      previousBodyOverflow =
        document.body.style.overflow;

      document.body.style.overflow =
        'hidden';

      lightbox.hidden =
        false;

      lightbox.setAttribute(
        'aria-hidden',
        'false'
      );

      document.addEventListener(
        'keydown',
        onLightboxKeydown
      );

      lightbox
        .querySelector(
          '.gbc-lightbox__close'
        )
        .focus();
    }

    var stageImg =
      $('gbc-stage');

    if (stageImg) {
      stageImg.setAttribute(
        'role',
        'button'
      );

      stageImg.setAttribute(
        'tabindex',
        '0'
      );

      stageImg.setAttribute(
        'aria-label',
        'Zoom'
      );

      stageImg.onclick =
        openLightbox;

      stageImg.onkeydown =
        function (e) {
          if (
            e.key === 'Enter' ||
            e.key === ' '
          ) {
            e.preventDefault();

            openLightbox();
          }
        };
    }

    // frecce galleria: legate una volta sola, leggono `gallery` dalla closure
    root
      .querySelectorAll(
        '.gbc-detail .gbc-nav'
      )
      .forEach(function (btn) {
        btn.onclick =
          function () {
            if (
              !gallery.length
            ) return;

            var d =
              parseInt(
                btn.getAttribute(
                  'data-dir'
                ),
                10
              );

            gi =
              (
                gi +
                d +
                gallery.length
              ) %
              gallery.length;

            paint();
          };
      });

    return {
      setData: function (data) {
        closeLightbox();
        data =
          data || {};

        variants =
          data.variants || [];

        subs =
          data.subcollections || [];

        groups = [];

        variants.forEach(function (v) {
          if (
            groups.indexOf(
              v.group
            ) < 0
          ) {
            groups.push(
              v.group
            );
          }
        });

        hasGroups =
          groups.length > 1 ||
          (
            groups.length === 1 &&
            !!groups[0]
          );

        curGroup =
          groups[0];

        vi = 0;
        gi = 0;
        gallery = [];

        var detail = root.querySelector('.gbc-detail');
        if (detail) detail.hidden = !variants.length;
        renderSubtabs();
        renderSwatches();
        selectVariant();
      }
    };
  }

  GBVariantExplorer.richText =
    richText;

  window.GBVariantExplorer =
    GBVariantExplorer;
})();
